/**
 * @generated SignedSource<<508b1bb43fd5852b002506db1395076a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PunchPassTemplateType = "RATE" | "TRANSPORTATION";
import { FragmentRefs } from "relay-runtime";
export type RoundPunchPassContent_Round$data = {
  readonly id: string;
  readonly player: {
    readonly fullName: string;
  } | null | undefined;
  readonly punchPassOptionsInvalid?: ReadonlyArray<{
    readonly id: string;
    readonly punchPassTemplate: {
      readonly type: PunchPassTemplateType;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined> | null | undefined;
  readonly punchPassOptionsOthersValid?: ReadonlyArray<{
    readonly id: string;
    readonly punchPassTemplate: {
      readonly type: PunchPassTemplateType;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined> | null | undefined;
  readonly punchPassOptionsSelfValid?: ReadonlyArray<{
    readonly id: string;
    readonly punchPassTemplate: {
      readonly type: PunchPassTemplateType;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined> | null | undefined;
  readonly ratePunchPass: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined;
  readonly transportationPunchPass: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined;
  readonly " $fragmentType": "RoundPunchPassContent_Round";
};
export type RoundPunchPassContent_Round$key = {
  readonly " $data"?: RoundPunchPassContent_Round$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoundPunchPassContent_Round">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PunchPassListItem_PunchPass"
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "kind": "Literal",
  "name": "valid",
  "value": true
},
v4 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "punchPassTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v1/*: any*/)
],
v5 = [
  {
    "alias": "punchPassOptionsSelfValid",
    "args": [
      {
        "kind": "Literal",
        "name": "appliesTo",
        "value": "SELF"
      },
      (v3/*: any*/)
    ],
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "punchPassOptions",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": "punchPassOptions(appliesTo:\"SELF\",valid:true)"
  },
  {
    "alias": "punchPassOptionsOthersValid",
    "args": [
      {
        "kind": "Literal",
        "name": "appliesTo",
        "value": "OTHERS"
      },
      (v3/*: any*/)
    ],
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "punchPassOptions",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": "punchPassOptions(appliesTo:\"OTHERS\",valid:true)"
  },
  {
    "alias": "punchPassOptionsInvalid",
    "args": [
      {
        "kind": "Literal",
        "name": "valid",
        "value": false
      }
    ],
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "punchPassOptions",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": "punchPassOptions(valid:false)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoundPunchPassContent_Round",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PunchPass",
      "kind": "LinkedField",
      "name": "ratePunchPass",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PunchPass",
      "kind": "LinkedField",
      "name": "transportationPunchPass",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v5/*: any*/),
      "type": "MemberRound",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v5/*: any*/),
      "type": "CustomerRound",
      "abstractKey": null
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};
})();

(node as any).hash = "b3b2c22a97c86237c0a8b7f384897353";

export default node;
